import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('CoreN20Dialog', {
    attrs: {
      "isOpen": "",
      "max-width": "900"
    },
    on: {
      "close": _vm.handleCloseDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._t("title", function () {
          return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.Templates.createDialog.title')) + "\n    ")];
        })];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('CoreButton', {
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-save",
            "disabled": _vm.saveDisabled,
            "data-cy": "btn_save_dtwin_template"
          },
          on: {
            "click": _vm.handleSave
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")])];
      },
      proxy: true
    }], null, true)
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "type": "text",
      "label": _vm.$i18n_t('DigitalTwin.Templates.createDialog.labelName'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": "",
      "data-cy": "template_name"
    },
    model: {
      value: _vm.title,
      callback: function ($$v) {
        _vm.title = $$v;
      },
      expression: "title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('CoreAccountSelector', {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.Templates.createDialog.labelAccount'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantId,
      callback: function ($$v) {
        _vm.tenantId = $$v;
      },
      expression: "tenantId"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('CoreDtwinFinder', {
    key: `tenantId-${_vm.tenantId}`,
    attrs: {
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenant-id": _vm.tenantId,
      "hide-details": "",
      "same-tenant": ""
    },
    model: {
      value: _vm.parentTwinId,
      callback: function ($$v) {
        _vm.parentTwinId = $$v;
      },
      expression: "parentTwinId"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };